"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.usePermissionsContext = exports.PermissionsContext = exports.Roles = void 0;

var _react = require("react");

var Roles;
exports.Roles = Roles;

(function (Roles) {
  Roles["SUPPLIER_ADMINS"] = "supplierAdmins";
  Roles["SUPPLIER_SALES_REPS"] = "supplierSalesReps";
  Roles["BUYER"] = "buyer";
})(Roles || (exports.Roles = Roles = {}));

var PermissionsContext = (0, _react.createContext)(null);
exports.PermissionsContext = PermissionsContext;

var usePermissionsContext = function usePermissionsContext() {
  var context = (0, _react.useContext)(PermissionsContext);

  if (context === null) {
    throw new Error('usePermissionsContext must be used within a PermissionsProvider');
  }

  return context;
};

exports.usePermissionsContext = usePermissionsContext;
//# sourceMappingURL=data:application/json;charset=utf-8;base64,eyJ2ZXJzaW9uIjozLCJzb3VyY2VzIjpbIi4uL3NyYy9QZXJtaXNzaW9uc0NvbnRleHQudHMiXSwibmFtZXMiOlsiUm9sZXMiLCJQZXJtaXNzaW9uc0NvbnRleHQiLCJ1c2VQZXJtaXNzaW9uc0NvbnRleHQiLCJjb250ZXh0IiwiRXJyb3IiXSwibWFwcGluZ3MiOiI7Ozs7Ozs7QUFBQTs7SUFFWUEsSzs7O1dBQUFBLEs7QUFBQUEsRUFBQUEsSztBQUFBQSxFQUFBQSxLO0FBQUFBLEVBQUFBLEs7R0FBQUEsSyxxQkFBQUEsSzs7QUFZTCxJQUFNQyxrQkFBa0IsR0FBRywwQkFDaEMsSUFEZ0MsQ0FBM0I7OztBQUlBLElBQU1DLHFCQUFxQixHQUFHLFNBQXhCQSxxQkFBd0IsR0FBOEI7QUFDakUsTUFBTUMsT0FBTyxHQUFHLHVCQUFXRixrQkFBWCxDQUFoQjs7QUFFQSxNQUFJRSxPQUFPLEtBQUssSUFBaEIsRUFBc0I7QUFDcEIsVUFBTSxJQUFJQyxLQUFKLENBQ0osaUVBREksQ0FBTjtBQUdEOztBQUVELFNBQU9ELE9BQVA7QUFDRCxDQVZNIiwic291cmNlc0NvbnRlbnQiOlsiaW1wb3J0IHsgY3JlYXRlQ29udGV4dCwgdXNlQ29udGV4dCB9IGZyb20gJ3JlYWN0JztcblxuZXhwb3J0IGVudW0gUm9sZXMge1xuICBTVVBQTElFUl9BRE1JTlMgPSAnc3VwcGxpZXJBZG1pbnMnLFxuICBTVVBQTElFUl9TQUxFU19SRVBTID0gJ3N1cHBsaWVyU2FsZXNSZXBzJyxcbiAgQlVZRVIgPSAnYnV5ZXInLFxufVxuXG5leHBvcnQgdHlwZSBQZXJtaXNzaW9uc0NvbnRleHRUeXBlID0ge1xuICBjb2duaXRvR3JvdXBzOiBSb2xlc1tdO1xuICBidXllcklkczogc3RyaW5nW107XG4gIHN1cHBsaWVySWQ/OiBzdHJpbmc7XG59O1xuXG5leHBvcnQgY29uc3QgUGVybWlzc2lvbnNDb250ZXh0ID0gY3JlYXRlQ29udGV4dDxQZXJtaXNzaW9uc0NvbnRleHRUeXBlIHwgbnVsbD4oXG4gIG51bGxcbik7XG5cbmV4cG9ydCBjb25zdCB1c2VQZXJtaXNzaW9uc0NvbnRleHQgPSAoKTogUGVybWlzc2lvbnNDb250ZXh0VHlwZSA9PiB7XG4gIGNvbnN0IGNvbnRleHQgPSB1c2VDb250ZXh0KFBlcm1pc3Npb25zQ29udGV4dCk7XG5cbiAgaWYgKGNvbnRleHQgPT09IG51bGwpIHtcbiAgICB0aHJvdyBuZXcgRXJyb3IoXG4gICAgICAndXNlUGVybWlzc2lvbnNDb250ZXh0IG11c3QgYmUgdXNlZCB3aXRoaW4gYSBQZXJtaXNzaW9uc1Byb3ZpZGVyJ1xuICAgICk7XG4gIH1cblxuICByZXR1cm4gY29udGV4dDtcbn07XG4iXX0=